import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Descriptions, Table, Button, Menu, Divider, Dropdown, Select, Empty } from 'antd';
import { createUseStyles } from 'react-jss'

import {
    MenuOutlined
} from '@ant-design/icons';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { Action, GET, POST, QueryDetail, QueryOrder, QueryParam, READWITH, deleteInArray, errorCatch, updateInArray } from 'fennec-ui'
import Rule from '../../../common/Rule'

import { DropdownAction } from 'fennec-ui'

import VPDNoviePotrebiteliIliIsklyuchenie from '../../forms/VPDNoviePotrebiteliIliIsklyuchenie'
import VPDZasedaniyaRegPravleniyaTekst from '../../forms/VPDZasedaniyaRegPravleniyaTekst'
import OtkritieRegistratsiiNaZasedanieRegionalnogoPravleniya from '../../forms/OtkritieRegistratsiiNaZasedanieRegionalnogoPravleniya'
import DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya from '../../forms/DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya'
import OtkritieZasedaniyaRegionalnogoPravleniya from '../../forms/OtkritieZasedaniyaRegionalnogoPravleniya'

import { If } from 'fennec-ui';
import PageLayout from '../../components/PageLayout';
import { useLocaladminContext } from '../../../common/Context';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const { Option } = Select;

const useStyles = createUseStyles({
    modal: {
        '& .ant-modal-title': {
            marginRight: "25px"
        }
    },
    divider: {
        '&.ant-divider-horizontal.ant-divider-with-text-left': {
            fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
            fontSize: "13px",
            fontWeight: "400",
            color: "rgb(0, 0, 0)",
        },
        '&.ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text': {
            padding: "0px",
            marginRight: "10px",
        }
    },
    block: {
        '& .buttons': {
            marginBottom: "10px"
        },
        // '& .buttons .ant-btn': {
        //     border: "none",
        //     '-webkit-box-shadow': "none",
        //     'box-shadow': "none"
        // }
    },
    actionTitle: {
        marginBottom: "5px"
    },

})

function PrisBtn(props) {
    const dispatch = useDispatch();
    const { auth, region, zasedanie, voprosi, prisutstvuyushchie, setVoprosi, setPrisutstvuyushchie } = props;

    // const zasedanie = useSelector(REDUX_ZasedaniyaRegionalnogoPravleniya.selector.objectByKey(region.ID));
    // const prisutstvuyushchie = useSelector(REDUX_DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya.selector.arrayByKey(zasedanie.ID));
    const pris_delete = () => {
        GET(auth, `/api/query-delete/DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya/${props?.object?.ID}`, ({ data }) => {
            setPrisutstvuyushchie(o => deleteInArray(o, props.object))
        }, errorCatch)
        // CRUDE_DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya.destroy(props.auth, () => {
        //     dispatch(REDUX_DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya.actions.setArrayByKey(zasedanie.ID, prisutstvuyushchie.filter(item => item.ID !== props.object.ID).sort((a, b) => {
        //         if (a.ID < b.ID) {
        //             return -1;
        //         }
        //         if (a.ID > b.ID) {
        //             return 1;
        //         }
        //         return 0;
        //     })));
        // }, props.object.ID);
    };
    if (props.object.fixed == true) return <></>;
    return (
        <Dropdown overlay={<Menu onClick={pris_delete} items={[
            { label: 'Удалить', key: 'item-1' }
        ]} />}>
            <Button size={"small"} style={{ padding: "0 6px" }} type="default">
                <MenuOutlined />
            </Button>
        </Dropdown>
    )
};
function VpdBtn(props) {
    const dispatch = useDispatch();
    const { auth, region, zasedanie, voprosi, prisutstvuyushchie, setVoprosi, setPrisutstvuyushchie } = props;
    // const zasedanie = useSelector(REDUX_ZasedaniyaRegionalnogoPravleniya.selector.objectByKey(region.ID));
    // const voprosi = useSelector(REDUX_VPDZasedaniyaRegPravleniya.selector.arrayByKey(zasedanie.ID));
    const vpd_delete = () => {
        GET(auth, `/api/query-delete/VPDZasedaniyaRegPravleniya/${props?.object?.ID}`, ({ data }) => {
            setVoprosi(o => deleteInArray(o, props.object))
        }, errorCatch)

        // CRUDE_VPDZasedaniyaRegPravleniya.destroy(props.auth, () => {
        //     dispatch(REDUX_VPDZasedaniyaRegPravleniya.actions.setArrayByKey(zasedanie.ID, voprosi.filter(item => item.ID !== props.object.ID)));
        // }, props.object.ID);
    };
    const update = (values, unlock, close) => {
        POST(auth, `/api/query-update/VPDZasedaniyaRegPravleniya`, { ...props.object, ...values }, ({ data }) => {
            if (close) close();
            setVoprosi(o => updateInArray(o, data))
        }, errorCatch)

        // CRUDE_VPDZasedaniyaRegPravleniya.update(props.auth, (data) => {
        //     if (close) close();
        //     dispatch(REDUX_VPDZasedaniyaRegPravleniya.actions.updateArrayByKey(zasedanie.ID, [data]));
        // }, { ...props.object, ...values }, dispatch);
    };
    if (props.object.fixed == true) return <></>;
    return (
        <DropdownAction items={[
            If(props.object.chlenFederatsiiID == null && props.object.otdelenieID == null, {
                ...props,
                region: region,
                object: props.object,
                zasedanie: zasedanie,
                voprosi: voprosi,
                prisutstvuyushchie: prisutstvuyushchie,
                mode: "MenuItem",
                action: update,
                title: "Редактировать",
                form: VPDZasedaniyaRegPravleniyaTekst,
                document: "vpdzasedaniyapravleniyafederatsiitekst"
            }),
            {
                title: "Удалить",
                mode: "MenuItem",
                action: vpd_delete
            }
        ]} />
    )
};
function ZasedaneRegiona(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { auth, regionalnoeOtdelenie } = props;

    const [zasedanie, setZasedanie] = useState();
    const [voprosi, setVoprosi] = useState();
    const [prisutstvuyushchie, setPrisutstvuyushchie] = useState();

    useEffect(() => {
        READWITH(auth, "ZasedaniyaRegionalnogoPravleniya", [
            QueryDetail("model"),
            QueryParam("w-regionalnoeOtdelenie.ID", regionalnoeOtdelenie?.ID),
            QueryParam("w-in-tekushchiiStatusZasedaniya.ID", "1,2")
            // tekushchiiStatusZasedaniyaID: 5
        ], ({ data }) => {
            if (data?.length) {
                setZasedanie(data[0]);
            }
        }, errorCatch)
    }, [regionalnoeOtdelenie]);

    useEffect(() => {
        if (zasedanie) {
            requestVoprosi(zasedanie);
            requestPrisutstvuyushchie(zasedanie);
        }
    }, [zasedanie]);

    const requestVoprosi = (zasedanie) => {
        if (zasedanie) {
            READWITH(auth, "VPDZasedaniyaRegPravleniya", [
                QueryDetail("model"),
                QueryParam("w-zasedanieRegionalnogoPravleniya.ID", zasedanie?.ID),
            ], ({ data }) => {
                setVoprosi(data);
            }, errorCatch)
        }
    };
    const requestPrisutstvuyushchie = (zasedanie) => {
        if (zasedanie) {
            READWITH(auth, "DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya", [
                QueryDetail("model"),
                QueryParam("w-zasedanieRegionalnogoPravleniya.ID", zasedanie?.ID),
                QueryOrder("chlenFederatsii.user.lastname", "ASC"),
                QueryOrder("chlenFederatsii.user.firstname", "ASC"),
                QueryOrder("chlenFederatsii.user.patronymic", "ASC"),
            ], ({ data }) => {
                setPrisutstvuyushchie(data);
            }, errorCatch)
        }
    };

    const openCallback = (res) => {
        setZasedanie(res.data.zasedanieRegionalnogoPravleniya);
        requestPrisutstvuyushchie(zasedanie);
    };
    const registerCallback = (res) => {
        setZasedanie(res.data.zasedanieRegionalnogoPravleniya);
        requestVoprosi(zasedanie);
        requestPrisutstvuyushchie(zasedanie);
    };
    const voprosiCallback = (res) => {
        if (res.data.length <= 0) return;
        setZasedanie(res.data[0].zasedanieRegionalnogoPravleniya);
        setVoprosi(o => updateInArray(o, res.data));
    };
    const prisutstvuyushchieCallback = (res) => {

        if (res.data.length <= 0) return;
        setZasedanie(res.data[0].zasedanieRegionalnogoPravleniya);
        setPrisutstvuyushchie(o => updateInArray(o, res.data));
    };
    const prisColumns = [
        {
            render: (text, record) => {
                return (record.chlenFederatsii.user.lastname + " " + record.chlenFederatsii.user.firstname + " " + record.chlenFederatsii.user.patronymic);
            }
        },
        {
            render: (text, record) => {
                if (record.predsedatelPravleniyaRegionalnogoOtdeleniyaID) return ("Председатель правления регионального отделения");
                if (record.revizorRegionalnogoOtdeleniyaID) return ("Ревизор регионального отделения");
                if (record.chlenRegPravleniyaID) return ("Член регионального правления");
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => (<PrisBtn region={regionalnoeOtdelenie}
                zasedanie={zasedanie}
                voprosi={voprosi}
                prisutstvuyushchie={prisutstvuyushchie}
                setVoprosi={setVoprosi}
                setPrisutstvuyushchie={setPrisutstvuyushchie}
                auth={auth} index={index + 1} object={record} callback={() => {
                    requestPrisutstvuyushchie(zasedanie);
                }} />),
        },
    ];
    const vpdColumns = [
        {
            title: '№',
            render: (text, record, index) => {
                return (index + 1);
            }
        },
        {
            title: 'Вопрос',
            render: (text, record) => {
                return (record.voprosPovestkiDnya);
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => (<VpdBtn region={regionalnoeOtdelenie}
                zasedanie={zasedanie}
                voprosi={voprosi}
                prisutstvuyushchie={prisutstvuyushchie}
                setVoprosi={setVoprosi}
                setPrisutstvuyushchie={setPrisutstvuyushchie}
                auth={auth} index={index + 1} object={record} callback={() => {
                    requestVoprosi(zasedanie);
                }} />),
        },
    ];

    return (
        <div>
            <Divider className={classes.divider} type="horizontal" orientation="left">
                Текущее заседание регионального правления
            </Divider>

            {(!zasedanie || !zasedanie.mestoProvedeniyaZasedaniya) ? (<Empty description={"Нет текущего заседания"} style={{ paddingBottom: "40px" }} />) : (
                <Descriptions bordered column={{ xs: 1, sm: 1, md: 1 }} size={"small"} >
                    <Descriptions.Item label="Номер протокола заседания">{zasedanie.nomerProtokolaZasedaniya}</Descriptions.Item>
                    <Descriptions.Item label="Дата заседания">{dayjs(zasedanie.dataZasedaniya).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm')}</Descriptions.Item>
                    <Descriptions.Item label="Место проведения заседания">{zasedanie.mestoProvedeniyaZasedaniya.name}</Descriptions.Item>
                    <Descriptions.Item label="Необходимый кворум">{zasedanie.neobkhodimiiKvorum}%</Descriptions.Item>
                    <Descriptions.Item label="Количество вопросов повестки дня">{voprosi?.length}</Descriptions.Item>
                </Descriptions>
            )}

            <Divider className={classes.divider} type="horizontal" orientation="left">
                Вопросы повестки дня
            </Divider>
            <Table columns={vpdColumns} dataSource={voprosi} pagination={false} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={"Нет вопросов повестки дня"}></Empty> }} size="small" rowKey={(r) => r.ID} />

            <Divider className={classes.divider} type="horizontal" orientation="left">
                Присутствующие на заседании
            </Divider>
            <Table columns={prisColumns} dataSource={prisutstvuyushchie} pagination={false} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={"Нет присутствующих на заседании"}></Empty> }} size="small" rowKey={(r) => r.ID} />

            <Rule type={"vpdnoviepotrebiteliiliisklyuchenie"} object={zasedanie}>
                <Action
                    auth={auth}
                    // callback={voprosiCallback}
                    object={regionalnoeOtdelenie}
                    zasedanie={zasedanie}
                    title={"ВПД Новые Потребители или Исключение"}
                    form={VPDNoviePotrebiteliIliIsklyuchenie}
                    // document={"vpdnoviepotrebiteliiliisklyuchenie"}
                    action={(values, unlock, close) => {
                        POST(auth, `/api/vpdnoviepotrebiteliiliisklyuchenie`, values,
                            (res) => {
                                voprosiCallback(res)
                                close()
                            }, (err) => errorCatch(err, unlock)
                        )
                    }}
                />
            </Rule>
            <Rule type={"vpdzasedaniyaregpravleniyatekst"} object={zasedanie}>
                <Action
                    auth={auth}
                    //  callback={voprosiCallback}
                    object={undefined}
                    region={regionalnoeOtdelenie}
                    zasedanie={zasedanie}
                    title={"ВПД Заседания Регионального Правления Текст"}
                    form={VPDZasedaniyaRegPravleniyaTekst}
                    //  document={"vpdzasedaniyaregpravleniyatekst"}
                    action={(values, unlock, close) => {
                        POST(auth, `/api/vpdzasedaniyaregpravleniyatekst`, values,
                            (res) => {
                                voprosiCallback(res)
                                close()
                            }, (err) => errorCatch(err, unlock)
                        )
                    }}
                />
            </Rule>
            <Rule type={"otkritieregistratsiinazasedanieregionalnogopravleniya"} object={zasedanie}>
                <Action
                    auth={auth}
                    // callback={registerCallback}
                    object={regionalnoeOtdelenie}
                    zasedanie={zasedanie}
                    title={"Открытие Регистрации На Заседание Регионального Правления"}
                    form={OtkritieRegistratsiiNaZasedanieRegionalnogoPravleniya}
                    // document={"otkritieregistratsiinazasedanieregionalnogopravleniya"}
                    action={(values, unlock, close) => {
                        POST(auth, `/api/otkritieregistratsiinazasedanieregionalnogopravleniya`, values,
                            (res) => {
                                registerCallback(res)
                                close()
                            }, (err) => errorCatch(err, unlock)
                        )
                    }}
                />
            </Rule>
            <Rule type={"dokumentprisutstvuyushchienazasedaniiregpravleniya"} object={zasedanie}>
                <Action
                    auth={auth}
                    // callback={prisutstvuyushchieCallback}
                    object={regionalnoeOtdelenie}
                    zasedanie={zasedanie}
                    title={"Присутствующие На Заседании Регионального Правления"}
                    form={DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya}
                    // document={"dokumentprisutstvuyushchienazasedaniiregpravleniya"}
                    action={(values, unlock, close) => {
                        POST(auth, `/api/dokumentprisutstvuyushchienazasedaniiregpravleniya`, values,
                            (res) => {
                                prisutstvuyushchieCallback(res)
                                close()
                            }, (err) => errorCatch(err, unlock)
                        )
                    }}
                />
            </Rule>
            <Rule type={"otkritiezasedaniyaregionalnogopravleniya"} object={zasedanie}>
                <Action
                    auth={auth}
                    object={regionalnoeOtdelenie}
                    zasedanie={zasedanie}
                    prisutstvuyushchie={prisutstvuyushchie}
                    title={"Открытие Заседания Регионального Правления"}
                    form={OtkritieZasedaniyaRegionalnogoPravleniya}

                    // document={"otkritiezasedaniyaregionalnogopravleniya"}
                    // callback={openCallback}
                    action={(values, unlock, close) => {
                        POST(auth, `/api/otkritiezasedaniyaregionalnogopravleniya`, values,
                            (res) => {
                                openCallback(res)
                                close()
                            }, (err) => errorCatch(err, unlock)
                        )
                    }}
                />
            </Rule>
        </div>
    );
}
export default function LocaladminGovernanceCurrentmeeting(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { status } = props;
    const { auth } = props;
    const local = useLocaladminContext();

    return (
        <PageLayout>
            <div style={{ backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ padding: "10px" }}>
                    {local && <ZasedaneRegiona auth={auth} regionalnoeOtdelenie={local}></ZasedaneRegiona>}
                </div>
            </div>
        </PageLayout>
    );
}
